import React from "react";
export const FixMyConflicts = ({
  className,
  fill = "#B54708",
  fillBG = "#FFFAEB",
}: {
  className?: string;
  fill?: string;
  fillBG?: string;
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="24" height="24" rx="6" fill={fillBG} />
      <g clipPath="url(#clip0_39_33237)">
        <path
          d="M16.6666 5.99984H17.3333C18.0666 5.99984 18.6666 6.59984 18.6666 7.33317V12.3332C18.6666 12.7014 18.3681 12.9998 17.9999 12.9998C17.6317 12.9998 17.3333 12.7014 17.3333 12.3332V9.33317H6.66659V17.3332C6.66659 17.6998 6.96659 17.9998 7.33325 17.9998H8.33325C8.70144 17.9998 8.99992 18.2983 8.99992 18.6665C8.99992 19.0347 8.70144 19.3332 8.33325 19.3332H6.66659C5.93325 19.3332 5.33325 18.7332 5.33325 17.9998V7.33317C5.33325 6.59984 5.93325 5.99984 6.66659 5.99984H7.33325V5.33317C7.33325 4.9665 7.63325 4.6665 7.99992 4.6665C8.36659 4.6665 8.66659 4.9665 8.66659 5.33317V5.99984H15.3333V5.33317C15.3333 4.9665 15.6333 4.6665 15.9999 4.6665C16.3666 4.6665 16.6666 4.9665 16.6666 5.33317V5.99984Z"
          fill={fill}
        />
        <path
          d="M13.5 12C11.568 12 10 13.568 10 15.5C10 17.432 11.568 19 13.5 19C15.432 19 17 17.432 17 15.5C17 13.568 15.432 12 13.5 12ZM12.5515 17.0015L11.295 15.745C11.1585 15.6085 11.1585 15.388 11.295 15.2515C11.4315 15.115 11.652 15.115 11.7885 15.2515L12.8 16.2595L15.208 13.8515C15.3445 13.715 15.565 13.715 15.7015 13.8515C15.838 13.988 15.838 14.2085 15.7015 14.345L13.045 17.0015C12.912 17.138 12.688 17.138 12.5515 17.0015Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_39_33237">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};
